import { Box, Grid, Paper, Typography } from '@material-ui/core'

import React from 'react'
import styled from 'styled-components'

const StyledPaper = styled(Paper)`
  width: 100%;
`
const Title = styled(Box)`
  height: 30px;
  margin: 20px;
  font-weight: 700;
`

const SettingTitleBar = () => (
  <Grid container style={{ width: '100%' }} alignItems="stretch">
    <StyledPaper>
      <Grid item xs={12}>
        <Typography component="h2" variant="h5">
          <Title>Setting</Title>
        </Typography>
      </Grid>
    </StyledPaper>
  </Grid>
)

export default SettingTitleBar
